module.exports = __webpack_public_path__ + "c18fe191040f00acd6250446cc7923c0.woff2";